<template>
  <div class="browse">
    <el-card class="box-card tablecard textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-cogs fs14" /> {{ cardtitle }} Information List</span>
      </div>
      <div>
      <el-row :gutter="30">
        <el-col :span="12">
          <div>Browse by Dataset Type</div>
          <el-select v-model="datasetval" placeholder="Please Selected" class="selecss" @change="handleDataset">
            <el-option
              v-for="item in datasetOpt"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div>Browse by Sample Type</div>
          <el-select v-model="sampleval" placeholder="Please Selected" class="selecss" @change="handleSample">
            <el-option
              v-for="item in sampleOpt"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="mt20 mb10">
        <div class="floatRight" style="margin-bottom: 10px;">
          Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
        </div>
        <div v-show="isProject">
          <el-table
            border
            stripe
            v-loading="loadingpro"
            empty-text="No Data"
            :data="proData"
            style="width: 100%"
            height="800"
            :row-key="getRowKeyspro"
            @sort-change="handleSort"
            :expand-row-keys="expandspro"
            @expand-change="handleExpand">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  border
                  v-loading="loadingpro2"
                  :data="props.row.subtableData"
                  style="width: 100%">
                  <!-- <el-table-column
                    prop=""
                    label=" "
                    width="50">
                  </el-table-column> -->
                  <el-table-column
                    prop="subtitle_en"
                    label="Subproject Title"
                    width="210"
                    :show-overflow-tooltip="isOverflow">
                    <template slot-scope="scope">
                      <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">
                        {{scope.row.subtitle_en}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="subproject_id"
                    label="Subproject ID">
                  </el-table-column>
                  <el-table-column
                    prop="px_id"
                    label="PXID">
                  </el-table-column>
                  <el-table-column
                    prop="species"
                    label="Species">
                  </el-table-column>
                  <el-table-column
                    prop="instrument"
                    label="Instrument"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    prop="fileCount"
                    label="File Count (size)">
                  </el-table-column>
                  <el-table-column
                    prop="submit_time"
                    label="Release Date">
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              label="ProjectName"
              prop="project_title_english"
              width="240"
              sortable
              :show-overflow-tooltip="isOverflow">
              <template slot-scope="scope">
                <span class="tablelink" @click="handleProurl(scope.row.project_id)">
                  {{scope.row.project_title_english}}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="ProjectID"
              prop="project_id"
              width="122"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Submission Type"
              prop="submission_type"
              width="104"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="PXID"
              prop="px_id"
              width="98"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Publication"
              prop="pubmed_id"
              sortable
              :show-overflow-tooltip="isOverflow">
              <template slot-scope="scope">
                <span>
                  <a :href="publictionUrl+scope.row.pubmed_id">{{scope.row.pubmed_id}}</a>
                  {{scope.row.reference}}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Submitter"
              prop="submitter"
              width="110"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Labhead"
              prop="lab_header"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Institution"
              prop="institution_english"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Subproject Count"
              prop="sub_count"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Project Status"
              prop="project_status"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Privacy"
              prop="project_privacy"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Release Date"
              prop="submit_time"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :current-page.sync.sync="curpagepro"
            :total="allNumpro"
            :page-size="pageSizepro"
            @current-change="handleChangepage"
            class="pagination mb10">
          </el-pagination>
        </div>
        <div v-show="isSubpro">
          <el-table
            height="500"
            class="mt10"
            empty-text="No Data"
            :data="subData"
            border
            stripe
            v-loading="loadingsub"
            @sort-change="handleSortsub"
            style="width: 100%">
            <el-table-column
              sortable
              :show-overflow-tooltip="isOverflow"
              prop="subtitle_en"
              label="Subproject">
              <template slot-scope="scope">
                <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">{{scope.row.subtitle_en}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Subproject ID"
              prop="subproject_id"
              width="140"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="PXID"
              prop="px_id"
              width="140"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Species"
              prop="species"
              width="130"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              prop="instrument"
              label="Instrument"
              width="160">
            </el-table-column>
            <el-table-column
              prop="fileCount"
              label="File Count (size)"
              width="160"
            >
            </el-table-column>
            <el-table-column
              prop="submit_time"
              label="Release Date"
              width="160"
              sortable>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :current-page.sync="curpagesub"
            :total="allNumsub"
            :page-size="pageSizesub"
            @current-change="handleChangepagesub"
            class="pagination mb10">
          </el-pagination>
        </div>
        <div v-show="isSuppro">
          <el-table
            class="mt10"
            empty-text="No Data"
            border
            stripe
            v-loading="loadingsup"
            :data="supData"
            style="width: 100%"
            :row-key="getRowKeyssup"
            @sort-change="handleSortsup"
            :expand-row-keys="expandssup"
            @expand-change="handleExpandsup">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  border
                  v-loading="loadingsup2"
                  :data="props.row.suptableData"
                  style="width: 100%">
                  <el-table-column
                    prop="project_title_english"
                    label="Project Title"
                    width="210"
                    :show-overflow-tooltip="isOverflow">
                    <template slot-scope="scope">
                      <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">
                        {{scope.row.project_title_english}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="project_id"
                    label="Project ID"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    prop="submission_type"
                    label="Submission Type"
                    width="130"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    prop="px_id"
                    label="PX ID"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    label="Publication"
                    prop="pubmed_id"
                    sortable
                    :show-overflow-tooltip="isOverflow">
                    <template slot-scope="scope">
                      <span>
                        <a :href="publictionUrl+scope.row.pubmed_id" target="_blank">{{scope.row.pubmed_id}}</a>
                        {{scope.row.reference}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="submitter"
                    label="Submitter"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    prop="lab_header"
                    label="Lab Head"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    prop="institution_english"
                    label="Institution"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    prop="sub_count"
                    label="Subproject Count"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    prop="submit_time"
                    label="Release Date"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              label="SuperProject Name"
              prop="sproject_name"
              sortable
              :show-overflow-tooltip="isOverflow">
              <template slot-scope="scope">
                <span class="tablelink" @click="handlesupProurl(scope.row.sproject_id)">
                  {{scope.row.sproject_name}}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="SuperProject ID"
              prop="sproject_id"
              width="160"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Lable"
              prop="sproject_label"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Description"
              prop="description"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Project Count"
              prop="pro_count"
              width="150"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :current-page.sync="curpagesup"
            :total="allNumsup"
            :page-size="pageSizesup"
            @current-change="handleChangepagesup"
            class="pagination mb10">
          </el-pagination>
        </div>
        <div v-show="isSample">
          <el-table
            height="500"
            class="mt10"
            empty-text="No Data"
            :data="samData"
            border
            stripe
            v-loading="loadingsam"
            @sort-change="handleSortsam"
            style="width: 100%">
            <el-table-column
              :show-overflow-tooltip="isOverflow"
              prop="object_name"
              :label="sampleval=='all' ? 'Sample Type' : sampleval">
            </el-table-column>
            <el-table-column
              label="NEWT/NCBI Taxon ID"
              prop="object_id"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Experiment_Count"
              prop="subproject_count"
              sortable
              :show-overflow-tooltip="isOverflow">
              <template slot-scope="scope">
                <span class="tablelink" @click="handleCount(scope.row)">
                  {{scope.row.subproject_count}}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :current-page.sync="curpagesam"
            :total="allNumsam"
            :page-size="pageSizesam"
            @current-change="handleChangepagesam"
            class="pagination mb10">
          </el-pagination>
        </div>
        <div v-show="isSubproCount">
          <el-table
            height="500"
            class="mt10"
            empty-text="No Data"
            :data="subcouData"
            border
            stripe
            v-loading="loadingsubcou"
            @sort-change="handleSortsubcou"
            style="width: 100%">
            <el-table-column
              sortable
              :show-overflow-tooltip="isOverflow"
              prop="subtitle_en"
              label="Subproject">
              <template slot-scope="scope">
                <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">{{scope.row.subtitle_en}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Subproject ID"
              prop="subproject_id"
              width="140"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="PXID"
              prop="px_id"
              width="140"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              label="Species"
              prop="species"
              width="130"
              sortable
              :show-overflow-tooltip="isOverflow">
            </el-table-column>
            <el-table-column
              prop="instrument"
              label="Instrument"
              width="160">
            </el-table-column>
            <el-table-column
              prop="fileCount"
              label="File Count (size)"
              width="160"
            >
            </el-table-column>
            <el-table-column
              prop="submit_time"
              label="Release Date"
              width="160"
              sortable>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :current-page.sync="curpagesubcou"
            :total="allNumsubcou"
            :page-size="pageSizesubcou"
            @current-change="handleChangepagesubcou"
            class="pagination mb10">
          </el-pagination>
        </div>
      </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { getBrowseSuperProjectList, getBrowseProjectList, getBrowseSubprojectList, getCvSampleTypes, getBrowseSubprojectBySampleType } from '@/api'
  export default {
    name: 'browse',
    data() {
      return {
        cardtitle: 'Project',
        datasetval: '1',
        datasetOpt: [{
          value: '1',
          label: 'Project'
        }, {
          value: '2',
          label: 'Subproject'
        }, {
          value: '3',
          label: 'Super Project'
        }],
        sampleval: '',
        sampleOpt: [{
          value: 'all',
          label: 'All'
        },{
          value: 'Species',
          label: 'Species'
        }, {
          value: 'Tissue',
          label: 'Tissue'
        }, {
          value: 'Cell',
          label: 'Cell'
        }, {
          value: 'Disease',
          label: 'Disease'
        }],
        isOverflow: true,
        tableHeader: [],
        publictionUrl: 'http://www.ncbi.nlm.nih.gov/pubmed?term=',
        pnameUrl: 'https://www.iprox.cn/page/project.html?id=',
        subpnameUrl: 'https://www.iprox.cn/page/subproject.html?id=',
        loadingpro: true,
        loadingpro2: true,
        loadingsub: true,
        loadingsup: true,
        loadingsup2: true,
        loadingsam: true,
        loadingsubcou: true,
        proData: [],
        subData: [],
        supData: [],
        samData: [],
        subcouData: [],
        curpagepro: 1,
        allNumpro: 0,
        pageSizepro: 20,
        curpagesub: 1,
        allNumsub: 0,
        pageSizesub: 20,
        curpagesup: 1,
        allNumsup: 0,
        pageSizesup: 20,
        curpagesam: 1,
        allNumsam: 0,
        pageSizesam: 20,
        curpagesubcou: 1,
        allNumsubcou: 0,
        pageSizesubcou: 20,
        ajax_data_list: {
          search:{
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: ""
          }
        },
        ajax_data_sublist: {
          search:{
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: ""
          }
        },
        ajax_data_suplist: {
          search:{
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: ""
          }
        },
        ajax_data_samlist: {
          search:{
            sample_type: '',
            sub: ''
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: '',
            type: ''
          }
        },
        ajax_data_countlist: {
          search:{
            sample_type: '',
            object_name: '',
            object_id: '',
            sub: ''
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: '',
            type: ''
          }
        },
        readData: {},
        expandspro: [],
        getRowKeyspro (row) {
          return row.project_id
        },
        expandssup: [],
        getRowKeyssup (row) {
          return row.sproject_id
        },
        subkindstr: '',
        subparams: '',
        searchkey: '',
        isProject: true,
        isSubpro: false,
        isSuppro: false,
        isSample: false,
        isSubproCount: false,
        orderConvert: {
          ascending: 'asc',
          descending: 'desc'
        }
      }
    },
    mounted() {
      // this.datasetval = this.$route.query.id
      if(this.$route.query.isSamCou && this.$route.query.isSamCou == 1) {
        this.cardtitle = 'Subproject'
        this.isProject = false
        this.isSubpro = false
        this.isSuppro = false
        this.isSample = false
        this.isSubproCount = true
        this.loadingsubcou = true
        this.ajax_data_countlist.search.sample_type = this.$route.query.sample_type
        this.ajax_data_countlist.search.object_name = this.$route.query.object_name
        this.ajax_data_countlist.search.object_id = this.$route.query.object_id
        this.ajax_data_countlist.search.sub = this.$route.query.sub
        getBrowseSubprojectBySampleType(this.ajax_data_countlist).then(res => {
          this.loadingsubcou = false
          let newData = res.result
          newData.forEach((val, index) => {
            let fileCount = val.file_count;
            let fileSize = this.handleFilesize(val.file_size)
            val.fileCount = fileCount + fileSize
          })
          this.subcouData = newData
          this.allNumsubcou = res.count
          this.datasetval = '2'
          this.sampleval = ''
        })
      } else {
        if(this.datasetval == '1') {
          this.ajax_data_list.search.sub = this.searchkey
          getBrowseProjectList(this.ajax_data_list).then(res => {
            this.loadingpro = false
            this.proData = res.result
            this.allNumpro = res.count
          })
        }
      }
    },
    created() {
      // this.tableHeader = this.commonHeaders
    },
    methods: {
      handleProurl(param) {
        let routerData = this.$router.resolve({path: '/project', query: {id: param}})
        window.open(routerData.href, '_blank')
      },
      handlesubProurl(param) {
        let routerData = this.$router.resolve({path: '/subproject', query: {id: param}})
        window.open(routerData.href, '_blank')
      },
      handleClick() {},
      handleChangepage (val) {
        this.loadingpro = true
        this.ajax_data_list.page.startPage = val
        // this.ajax_data_list.filters[0].equals = this.kindVal
        // this.ajax_data_list.filters[1].equals = params.data.name
        getBrowseProjectList(this.ajax_data_list).then(res => {
          this.loadingpro = false
          // console.log(res)
          this.proData = res.result
          this.allNumpro = res.count
        })
      },
      handleSort (column, prop, order) {
        // console.log(column, prop, order)
        this.loadingpro = true
        this.ajax_data_list.order.item = column.prop
        this.ajax_data_list.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getBrowseProjectList(this.ajax_data_list).then(res => {
            this.loadingpro = false
            this.proData = res.result
            this.allNumpro = res.count
          })
        } else {
          this.loadingpro = false
        }
      },
      handleExpand(row, expandedRows) {
        this.loadingpro2 = true
        // console.log(row, expandedRows)
        this.expandspro = []
        if (expandedRows.length) {
          expandedRows.map((item, key) => {
            this.expandspro.push(item.project_id)
          })
          this.ajax_data_sublist.search.project_id = row.project_id
          this.ajax_data_sublist.page.startPage = 1
          getBrowseSubprojectList(this.ajax_data_sublist).then(res => {
            this.loadingpro2 = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            let subList = newData
            // console.log(subList)
            row.subtableData = subList
          })
        } else {
          this.expandspro = []
        }
      },
      handleChangepagesub(val) {
        this.loadingsub = true
        this.ajax_data_sublist.page.startPage = val
        getBrowseSubprojectList(this.ajax_data_sublist).then(res => {
          this.loadingsub = false
          // console.log(res)
          this.subData = res.result
          this.allNumsub = res.count
        })
      },
      handleSortsub (column, prop, order) {
        // console.log(column, prop, order)
        this.loadingsub = true
        this.ajax_data_sublist.order.item = column.prop
        this.ajax_data_sublist.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getBrowseSubprojectList(this.ajax_data_sublist).then(res => {
            this.loadingsub = false
            this.subData = res.result
            this.allNumsub = res.count
          })
        } else {
          this.loadingsub = false
        }
      },
      handleChangepagesup(val) {
        this.loadingsup = true
        this.ajax_data_suplist.page.startPage = val
        getBrowseSuperProjectList(this.ajax_data_suplist).then(res => {
          this.loadingsup = false
          // console.log(res)
          this.supData = res.result
          this.allNumsup = res.count
        })
      },
      handleSortsup(column, prop, order) {
        // console.log(column, prop, order)
        this.loadingsup = true
        this.ajax_data_suplist.order.item = column.prop
        this.ajax_data_suplist.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getBrowseSuperProjectList(this.ajax_data_suplist).then(res => {
            this.loadingsup = false
            this.supData = res.result
            this.allNumsup = res.count
          })
        } else {
          this.loadingsup = false
        }
      },
      handleExpandsup(row, expandedRows) {
        this.loadingsup2 = true
        // console.log(row, expandedRows)
        this.expandssup = []
        if (expandedRows.length) {
          expandedRows.map((item, key) => {
            this.expandssup.push(item.sproject_id)
          })
          this.ajax_data_list.search.superproject_id = row.sproject_id
          this.ajax_data_list.page.startPage = 1
          getBrowseProjectList(this.ajax_data_list).then(res => {
            this.loadingsup2 = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            let dataList = newData
            // console.log(subList)
            row.suptableData = dataList
          })
        } else {
          this.expandssup = []
        }
      },
      handleChangepagesam(val) {
        this.loadingsam = true
        this.ajax_data_samlist.page.startPage = val
        getCvSampleTypes(this.ajax_data_samlist).then(res => {
          this.loadingsam = false
          // console.log(res)
          this.samData = res.result
          this.allNumsam = res.count
        })
      },
      handleSortsam (column, prop, order) {
        // console.log(column, prop, order)
        this.loadingsam = true
        this.ajax_data_samlist.order.item = column.prop
        this.ajax_data_samlist.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getCvSampleTypes(this.ajax_data_samlist).then(res => {
            this.loadingsam = false
            this.samData = res.result
            this.allNumsam = res.count
          })
        } else {
          this.loadingsam = false
        }
      },
      handleChangepagesubcou(val) {
        this.isProject = false
        this.isSubpro = false
        this.isSuppro = false
        this.isSample = false
        this.isSubproCount = true
        this.loadingsubcou = true
        this.ajax_data_countlist.search.sample_type = this.$route.query.sample_type
        this.ajax_data_countlist.search.object_name = this.$route.query.object_name
        this.ajax_data_countlist.search.object_id = this.$route.query.object_id
        this.ajax_data_countlist.search.sub = this.$route.query.sub
        this.ajax_data_countlist.page.startPage = val
        getBrowseSubprojectBySampleType(this.ajax_data_countlist).then(res => {
          this.loadingsubcou = false
          let newData = res.result
          newData.forEach((val, index) => {
            let fileCount = val.file_count;
            let fileSize = this.handleFilesize(val.file_size)
            val.fileCount = fileCount + fileSize
          })
          this.subcouData = newData
          this.allNumsubcou = res.count
          this.datasetval = '2'
          this.sampleval = ''
        })
      },
      handleSortsubcou (column, prop, order) {
        // console.log(column, prop, order)
        this.loadingsubcou = true
        this.ajax_data_countlist.order.item = column.prop
        this.ajax_data_countlist.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getBrowseSubprojectBySampleType(this.ajax_data_countlist).then(res => {
            this.loadingsubcou = false
            this.subcouData = res.result
            this.allNumsubcou = res.count
          })
        } else {
          this.loadingsubcou = false
        }
      },
      handleDataset() {
        this.sampleval = ''
        if(this.datasetval == '1') {
          this.cardtitle = 'Project'
          this.isProject = true
          this.isSubpro = false
          this.isSuppro = false
          this.isSample = false
          this.isSubproCount = false
          this.loadingpro = true
          this.ajax_data_list.search.sub = this.searchkey
          this.ajax_data_list.search.superproject_id = ''
          // this.ajax_data_list.page.startPage = 1
          getBrowseProjectList(this.ajax_data_list).then(res => {
            this.loadingpro = false
            this.proData = res.result
            this.allNumpro = res.count
          })
        } else if(this.datasetval == '2') {
          this.cardtitle = 'Subproject'
          this.isProject = false
          this.isSubpro = true
          this.isSuppro = false
          this.isSample = false
          this.isSubproCount = false
          this.loadingsub = true
          this.ajax_data_sublist.search.sub = this.searchkey
          this.ajax_data_sublist.search.project_id = ''
          // this.ajax_data_sublist.page.startPage = 1
          getBrowseSubprojectList(this.ajax_data_sublist).then(res => {
            this.loadingsub = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            this.subData = newData
            this.allNumsub = res.count
          })
        } else if(this.datasetval == '3') {
          this.cardtitle = 'Superproject'
          this.isProject = false
          this.isSubpro = false
          this.isSuppro = true
          this.isSample = false
          this.isSubproCount = false
          this.loadingsup = true
          this.ajax_data_suplist.search.sub = this.searchkey
          // this.ajax_data_suplist.page.startPage = 1
          getBrowseSuperProjectList(this.ajax_data_suplist).then(res => {
            this.loadingsup = false
            this.supData = res.result
            this.allNumsup = res.count
          })
        }
      },
      handleSample() {
        this.cardtitle = 'Field'
        this.isProject = false
        this.isSubpro = false
        this.isSuppro = false
        this.isSample = true
        this.isSubproCount = false
        this.datasetval = ''
        // this.ajax_data_samlist.page.startPage = 1
        this.ajax_data_samlist.search.sample_type = this.sampleval
        getCvSampleTypes(this.ajax_data_samlist).then(res => {
          this.loadingsam = false
          this.samData = res.result
          this.allNumsam = res.count
        })
      },
      handleSearch() {
        if(this.datasetval != '' && this.sampleval == '') {
          if(this.datasetval == '1') {
            this.isProject = true
            this.isSubpro = false
            this.isSuppro = false
            this.isSample = false
            this.isSubproCount = false
            this.loadingpro = true
            this.ajax_data_list.search.sub = this.searchkey
            this.ajax_data_list.page.startPage = 1
            getBrowseProjectList(this.ajax_data_list).then(res => {
              this.loadingpro = false
              this.proData = res.result
              this.allNumpro = res.count
            })
          } else if(this.datasetval == '2') {
            this.isProject = false
            this.isSubpro = true
            this.isSuppro = false
            this.isSample = false
            this.isSubproCount = false
            this.loadingsub = true
            this.ajax_data_sublist.search.sub = this.searchkey
            this.ajax_data_sublist.page.startPage = 1
            getBrowseSubprojectList(this.ajax_data_sublist).then(res => {
              this.loadingsub = false
              let newData = res.result
              newData.forEach((val, index) => {
                let fileCount = val.file_count;
                let fileSize = this.handleFilesize(val.file_size)
                val.fileCount = fileCount + fileSize
              })
              this.subData = newData
              this.allNumsub = res.count
            })
          } else if(this.datasetval == '3') {
            this.isProject = false
            this.isSubpro = false
            this.isSuppro = true
            this.isSample = false
            this.isSubproCount = false
            this.loadingsup = true
            this.ajax_data_suplist.search.sub = this.searchkey
            this.ajax_data_suplist.page.startPage = 1
            getBrowseSuperProjectList(this.ajax_data_suplist).then(res => {
              this.loadingsup = false
              this.supData = res.result
              this.allNumsup = res.count
            })
          }
        } else if (this.datasetval == '' && this.sampleval != '') {
          this.isProject = false
          this.isSubpro = false
          this.isSuppro = false
          this.isSample = true
          this.isSubproCount = false
          this.ajax_data_samlist.search.sample_type = this.sampleval
          this.ajax_data_samlist.search.sub = this.searchkey
          getCvSampleTypes(this.ajax_data_samlist).then(res => {
            this.loadingsam = false
            this.samData = res.result
            this.allNumsam = res.count
          })
        }
        
      },
      handleCount(dataArr) {
        let routerData = this.$router.resolve({path: '/browse', query: {isSamCou: 1, sample_type: this.sampleval, sub: this.searchkey, object_name: dataArr.object_name, object_id: dataArr.object_id}})
        window.open(routerData.href, '_blank')
        // this.isProject = false
        // this.isSubpro = true
        // this.isSuppro = false
        // this.isSample = false
        // this.loadingsub = true
        // this.ajax_data_countlist.search.sample_type = this.sampleval
        // this.ajax_data_countlist.search.object_name = dataArr.object_name
        // this.ajax_data_countlist.search.object_id = dataArr.object_id
        // this.ajax_data_countlist.search.sub = this.searchkey
        // getBrowseSubprojectBySampleType(this.ajax_data_countlist).then(res => {
        //   this.loadingsub = false
        //   let newData = res.result
        //   newData.forEach((val, index) => {
        //     let fileCount = val.file_count;
        //     let fileSize = this.handleFilesize(val.file_size)
        //     val.fileCount = fileCount + fileSize
        //   })
        //   this.subData = newData
        //   this.allNumsub = res.count
        // })
      },
      handleFilesize(param) {
        let fileSize = param;
        if (fileSize == 0 || fileSize == null) {
          fileSize = ' (' + 0 +'K)';
        } else if (fileSize < 1024) {
          fileSize = ' (' + fileSize.toFixed(2) + 'K)';
        } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
          fileSize =  ' (' + (fileSize / 1024).toFixed(2)+ 'M)'
        } else {
          fileSize =   ' ('
            + (fileSize / 1024 / 1024).toFixed(2)
            + 'G)'
        }
        return fileSize
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .browse {
    .selecss {
      width: 100%;
    }
  }
</style>
